import ShareMsgBase from './A_G.ShareMsgBase';

class MsgBeaten extends ShareMsgBase {
  /**
   * The message that is sent when you beat a friend's score
   * @param {Object} user1
   * @param {Object} user2
   * @param {*} onAllImagesReadyCallback
   */
  constructor(user1, user2, onAllImagesReadyCallback = null) {
    super(3, onAllImagesReadyCallback);

    const lvlNr = game.state.getCurrentState().lvlIndex + 1;

    if (!user1.avatar) user1.avatar = user1.image;
    if (!user2.avatar) user2.avatar = user2.image;

    this.bg = this._addExtImage(0, 0, 'img/Msg_Friend_Beaten.png', 0);

    this.friendsBeaten = this.add(new G.Text(336, 40, 'Friend beaten!', {
      style: 'msg-white',
      fontSize: '50px',
    }, 0.5, 480));

    this.avatar1 = this._addExtImage(163, 129, user1.avatar, 0, 94);

    this.name1 = this.add(new G.Text(100, 156, user1.name, 'msg-white', 0.5, 100));
    this.name1.setShadow(1, 2, 'rgba(0,0,0,0.5)', 1);

    this.score1 = this.add(new G.Text(100, 193, user1.score, {
      style: 'msg-white',
      fontSize: '45px',
    }, 0.5, 100));
    this.score1.setShadow(1, 2, 'rgba(0,0,0,0.5)', 1);

    this.name2 = this.add(new G.Text(577, 175, user2.name, 'msg-white', 0.5, 100));
    this.name2.setShadow(1, 2, 'rgba(0,0,0,0.5)', 1);

    this.score2 = this.add(new G.Text(577, 212, user2.score, {
      style: 'msg-white',
      fontSize: '45px',
    }, 0.5, 100));
    this.score2.setShadow(1, 2, 'rgba(0,0,0,0.5)', 1);

    const msg = ' scored higher than ';

    this.desc = this.add(new G.Text(336, 325, `${user1.name} ${msg} ${user2.name}!`, 'msg-yellow', 0.5, 580));

    this.desc.addColor('#ffffff', user1.name.length);
    this.desc.addColor('#ffe715', msg.length + user1.name.length);
    this.desc.addColor('#ffffff', msg.length + user1.name.length + user2.name.length);

    this.levelTxt = this.add(new G.Text(336, 145, 'Level', 'msg-fuschia', 0.5, 200));
    this.levelTxt.padding.x += 5;
    this.levelTxt.padding.y += 5;
    this.levelTxt.setShadow(1, 2, 'rgba(0,0,0,0.3)', 2, true, false);

    this.levelNrTxt = this.add(new G.Text(336, 200, lvlNr.toString(), {
      style: 'msg-fuschia',
      fontSize: '70px',
    }, 0.5, 200));
    this.levelNrTxt.padding.x += 5;
    this.levelNrTxt.padding.y += 5;
    this.levelNrTxt.setShadow(1, 2, 'rgba(0,0,0,0.3)', 2, true, false);

    this.avatar2 = this._addExtImage(418, 149, user2.avatar, 0, 94);
  }
}

// create global references
G.MsgBeaten = MsgBeaten;
